exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th{text-align:center}.skill-controls{width:100%}.skill-control td{padding:.5rem 0}.skill-control__name{text-align:left;font-size:1.8rem}.skill-control__name div{margin-left:1rem}.skill-control:nth-child(2n){background:#eee}.pretty .state .label:after,.pretty .state .label:before{top:50%;transform:translateY(-50%)}.pretty input:checked~.state label:after{background-color:var(--light-color)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c4a6279","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SelectSkills.vue
// module id = 78
// module chunks = 0